// extracted by mini-css-extract-plugin
export var backdropBlur = "_c8-0";
export var contentCard = "_c8-5";
export var frame = "_c8-2";
export var image = "_c8-4";
export var imagePane = "_c8-3";
export var modal = "_c8-1";